// extracted by mini-css-extract-plugin
export default {"container":"tooltip_container__p-mKX","tooltipIcon":"tooltip_tooltipIcon__i5rf+"};